import { AttributeObject } from '../../utilities/attributes.util';


export const jobAttributeTitles: AttributeObject[] = [
	{
		title: 'Notifications Disabled',
		attribute: 'notifications::disabled',
	}
];
